export const TO_DO_LEE = require('./images/TO_DO_LEE.png');
export const TRASH = require('./images/TRASH.png');
export const FLAG = require('./images/FLAG.png');
export const EDIT = require('./images/EDIT.png');
export const PLUS = require('./images/PLUS.png');
